import type { RichTextType } from 'components/RichText/types';

export function isRichText(richText: any): richText is RichTextType {
  return richText?.raw !== undefined;
}
